'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/react.js
 ** module id = 34
 ** module chunks = 0
 **/